import { autoCapitalize } from '@/utils/autoCapitalize'
import { AddressByCepData } from './AddressByCepMapper.types'

class AddressByCepMapper {
  toDomain(persistenceAddress: AddressByCepData) {
    return {
      city: autoCapitalize(persistenceAddress?.localidade),
      street: autoCapitalize(persistenceAddress?.logradouro),
      state: autoCapitalize(persistenceAddress?.uf),
      neighborhood: autoCapitalize(persistenceAddress?.bairro),
    }
  }
}

export default new AddressByCepMapper()
